export enum ListLayout {
  Grid = "1",
  List = "2",
}
